import {
  Component,
} from "react";
import $ from "jquery";

import store from "CommonState/store";

@store("user")
export default class TokenRefresher extends Component {
  componentDidMount() {
    this.loginRefreshToken = setInterval(this.props.refreshLoginToken, this.expiresMs - 2 * 60 * 1000);
    this.startLogoutCountdown();

    $(document).on("keypress", this.startLogoutCountdown);
    $(document).on("mousedown", this.startLogoutCountdown);
  }

  componentWillUnmount() {
    if (this.loginRefreshToken) {
      clearInterval(this.loginRefreshToken);
      this.loginRefreshToken = null;
    }
    if (this.logoutToken) {
      clearTimeout(this.logoutToken);
      this.logoutToken = null;
    }

    $(document).off("keypress", this.startLogoutCountdown);
    $(document).off("mousedown", this.startLogoutCountdown);
  }

  render() {
    return null;
  }

  get expiresMs() {
    return this.props.user.expires;
  }

  startLogoutCountdown = () => {
    if (this.logoutToken) {
      clearTimeout(this.logoutToken);
    }
    this.logoutToken = setTimeout(this.doLogout, this.expiresMs);
  };

  doLogout = () => {
    this.props.logout();
  };
}
